import { render, staticRenderFns } from "./OEmbed.vue?vue&type=template&id=58df0ef9&scoped=true&"
import script from "./OEmbed.vue?vue&type=script&lang=js&"
export * from "./OEmbed.vue?vue&type=script&lang=js&"
import style0 from "./OEmbed.vue?vue&type=style&index=0&id=58df0ef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df0ef9",
  null
  
)

export default component.exports